import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { getStaticImageSrc } from '#/utils/getImageSrc';

const MAX_COVER_WIDTH = 1440;
const COVER_HEIGHT = 280;

type Props = {
  data: ApiFilestackImageData | null;
  qaId?: string;
};

export function ViewUserProfilePageBannerImage({ data, qaId }: Props) {
  if (!data) {
    return (
      <img
        src={getStaticImageSrc('backgrounds/user-profile-bg.svg')}
        width="1430"
        height="370"
        alt=""
        data-qa-id={qaId}
        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
      />
    );
  }

  return (
    <FilestackImage
      data={data}
      width={MAX_COVER_WIDTH}
      height={COVER_HEIGHT}
      objectFit="cover"
      eagerLoad
      skeleton
      qaId={qaId}
    />
  );
}
